import CustomCheckbox from 'Common/CustomCheckbox';
import CustomInput from 'Common/CustomInput';
import CustomTextarea from 'Common/CustomTextArea';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import api from 'http';
import React, { useEffect, useState } from 'react';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import Validator, { ValidationTypes as V_Type, } from "react-form-supervalidator";
import { toast } from 'react-toastify';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';


const AddNewTagPopup = ({ onClose, tagId, allowActive, disableDraggable }) => {
    const uniqueId = "AddNewTagPopup"
    const [labelData, setLabelData] = useState({
        "practiceId": 0,
        "addedBy": "",
        "inActive": false,
        "id": 0,
        "name": "",
        "description": "",
        "colorCode": "#000000",
        "isActive": true
    });
    const [loading, setLoading] = useState(false);
    const [validationModel, setValidationModel] = useState({
        colorCodeError: null,
        nameError: null,
    })

    const setValidation = () => {
        let validation_Obj = {
            ...validationModel,
            colorCodeError: Validator(labelData.colorCode, [V_Type.required], ['Color is required'],),
            nameError: Validator(labelData.name, [V_Type.required], ['Name is required'],),
        }
        setValidationModel(validation_Obj)
        return Validator(validation_Obj, V_Type.NullCheck);
    }

    const handleChange = (e) => {
        let { name, value, type, checked } = e.target;
        if (name === "description") {
            value = value.trimStart();
            if (value.length > 500) {
                return
            }
        }
        setLabelData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? !checked : value
        }));
    };

    const handleSubmit = async () => {
        let my_validation = setValidation();
        if (my_validation) {
        }
        else {
            try {
                setLoading(true)
                const resp = await api.post(`${process.env.REACT_APP_TC_TASK}/api/Tag/SaveTag`, labelData)
                const obj = {
                    id: resp.data.dataModel.id,
                    label: `${resp.data.dataModel.colorCode}:${resp.data.dataModel.name}`,
                    value: "" + resp.data.dataModel.id,
                }
                toast.success(resp.data.responseMessage)
                onClose(obj);
            } catch (error) {
                ErrorHandlingMessage(error)
            }
            finally {
                setLoading(false)
            }
        }


    };

    useEffect(() => {
        (async () => {
            if (tagId) {
                try {
                    setLoading(true)
                    const response = await api.get(`${process.env.REACT_APP_TC_TASK}/api/Tag/FindTag/${tagId}`)
                    setLabelData(response.data.dataModel)

                } catch (error) {
                    ErrorHandlingMessage(error)
                }
                finally {
                    setLoading(false)
                }
            }
        })();
    }, [tagId])

    return (
        <ReactPortal wrapperId={uniqueId}>
            {loading && <FullPageLoader allowFullScreen />}
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[700px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            {tagId ? "Update" : "Create"} Tag
                        </div>
                        <div className="px-5 overflow-y-auto max-h-[70vh] pt-3">
                            <div className="grid grid-cols-12 gap-4">
                                <div className="col-span-12 md:col-span-9">
                                    <CustomInput
                                        name="name"
                                        value={labelData.name}
                                        onChange={handleChange}
                                        label="Name"
                                        type="text"
                                        toLower
                                        placeholder="Please Enter Name"
                                        required={true}
                                    />
                                    {validationModel.nameError}
                                </div>

                                <div className="col-span-12 md:col-span-3">
                                    <CustomInput
                                        name="colorCode"
                                        value={labelData.colorCode}
                                        onChange={handleChange}
                                        label="Color"
                                        placeholder="Enter Color"
                                        required={true}
                                        toLower
                                        type="color"
                                    />
                                    {validationModel.colorCodeError}
                                </div>

                                <div className="col-span-12 md:col-span-12 ">
                                    <CustomTextarea
                                        name="description"
                                        value={labelData.description}
                                        onChange={handleChange}
                                        label={"Description"}
                                        maxWidth="700px"
                                        rows={4}

                                    />
                                    {validationModel.descriptionError}
                                    <div className='text-right'>
                                        <span> {labelData.description?.length} </span>
                                        <span>/ 500</span>
                                    </div>
                                </div>
                                {allowActive && (
                                    <div className="col-span-12 md:col-span-4">
                                        <CustomCheckbox checked={labelData.isActive} name="isActive" onChange={handleChange} label={"Active"} />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew label="Cancel" variant="outline" onClick={() => onClose()} />
                            <CustomButtonNew label={tagId ? "Update" : "Save"} onClick={handleSubmit} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    );
}

export default AddNewTagPopup;
